
import { useEffect } from 'react'
import Select from 'react-select'
import { DepartmentDDLAPI, DistributionLineLocationDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { useSearchParams } from 'react-router-dom'

export const DistributionLineLocationDataDDL = (props) => {
    const { DistributionLineLocationDDL, setDistributionLineLocationDDL, CropNameDashboardData, PopUpField, IsPost, WardName, rowData, Flag} = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    console.log('DashProjectTypeId', DashProjectTypeId)

    useEffect(() => {
        const data = {
            // M_WardID: '1',
            M_UserID: UserID,
            token: token,
            M_WardID: WardName.ID,
            DashProjectTypeId: DashProjectTypeId
        }
        { (WardName.ID != 0) && dispatch(DistributionLineLocationDDLAPI({ data })) }
    }, [IsPost, WardName.ID, DashProjectTypeId])

    const { DistributionLineLocationData } = useSelector(state => state.DistributionLineLocationDDLData)

    useEffect(() => {
        handleLocationNameDDL()
    }, [DistributionLineLocationData])

    const handleLocationNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (DistributionLineLocationData && DistributionLineLocationData.table && DistributionLineLocationData.table.length > 0) {

            if (DashProjectTypeId && DashProjectTypeId == 9) { // TTP
                let list = DistributionLineLocationData.table.map((item, index) => ({
                    value: item.m_ttP_LocationID,
                    label: item.locationDetails,
                }))

                setDistributionLineLocationDDL({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_ttP_LocationID : 0,
                    Label: Flag === 'Update' ? rowData.locationDetails : "Select...",
                })
            } else {
                let list = DistributionLineLocationData.table.map((item, index) => ({
                    value: item.m_Distri_WS_LocationID,
                    label: item.locationDetails,
                }))

                setDistributionLineLocationDDL({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_Distri_WS_LocationID : 0,
                    Label: Flag === 'Update' ? rowData.locationDetails : "Select...",
                })
            }

        }
        else {
            setDistributionLineLocationDDL({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Location Name  </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width3"
                isSearchable
                maxMenuHeight={115}
                value={{ value: DistributionLineLocationDDL.ID, label: DistributionLineLocationDDL.Label }}
                onChange={(e) => {
                    e ?
                        setDistributionLineLocationDDL({ ...DistributionLineLocationDDL, ID: e.value, Label: e.label })
                        :
                        setDistributionLineLocationDDL({ ...DistributionLineLocationDDL, ID: 0, Label: "Select..." })

                }}
                options={DistributionLineLocationDDL.DDL}
            />
        </div>
    )
}